<template>
    <form class="admin-linear-form" @submit.prevent="storePermission" @keydown="permissionForm.errors.clear($event.target.name)">
        <div class="admin-linear-field">
            <label>{{trans('permission.name')}}</label>
            <input class="form-control" type="text" value="" v-model="permissionForm.name" name="name" :placeholder="trans('permission.name')">
            <show-error :form-name="permissionForm" prop-name="name"></show-error>
        </div>
        <div class="admin-linear-form__actions">
            <button type="button" class="btn btn-sm admin-form-btn-cancel" @click="$emit('cancel')">
                {{trans('general.cancel')}}
            </button>
            <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">
                <span>{{trans('general.save')}}</span>
            </button>
        </div>
    </form>
</template>


<script>
    export default {
        data() {
            return {
                permissionForm: new Form({
                    'name' : ''
                })
            };
        },
        methods: {
            storePermission(){
                this.permissionForm.post('/api/permission')
                    .then(response => {
                        toastr.success(response.message);
                        this.$emit('completed')
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>

<style scoped>
.admin-linear-form {
    display: grid;
    gap: 1rem;
}

.admin-linear-field label {
    display: block;
    margin-bottom: 0.45rem;
    color: var(--dash-pro-text);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.admin-linear-form__actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.65rem;
    padding-top: 0.35rem;
}
</style>
